import { put } from "redux-saga/effects";
import axiosGovernorate from "../../axios-governorate";
import * as actions from "../actions";
import { POST_CONTEXT } from "../../lib/enums";

export function* getMailPostsSaga({ page }: any) {
  try {
    const response = yield axiosGovernorate.get(`/api/mail/posts/${page}`);

    const { mail, newPosts } = JSON.parse(response.data).data;
    yield put(actions.updateState({ mail, newPosts }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* sendPostSaga({ recipient, content }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "sendPost",
      context: POST_CONTEXT.Mail,
      gn: recipient,
      content
    });

    const { mail } = JSON.parse(response.data).data;
    yield put(actions.updateState({ mail }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* deletePostsSaga({ postIds }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "deletePosts",
      context: POST_CONTEXT.Mail,
      postIds
    });

    const { mail } = JSON.parse(response.data).data;
    yield put(actions.updateState({ mail }));

    yield put(actions.closeDialog());
  } catch (error) {
    console.log(error.message);
    yield put(actions.closeDialog());
  }
}
